import { render, staticRenderFns } from "./CustomerQuery.vue?vue&type=template&id=5d0ef466&scoped=true"
import script from "./CustomerQuery.vue?vue&type=script&lang=js"
export * from "./CustomerQuery.vue?vue&type=script&lang=js"
import style0 from "./CustomerQuery.vue?vue&type=style&index=0&id=5d0ef466&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5d0ef466",
  null
  
)

export default component.exports